import { render } from "./StudioColorPickerInput.vue?vue&type=template&id=212e31fc&scoped=true"
import script from "./StudioColorPickerInput.vue?vue&type=script&lang=js"
export * from "./StudioColorPickerInput.vue?vue&type=script&lang=js"

import "./StudioColorPickerInput.vue?vue&type=style&index=0&id=212e31fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212e31fc"]])

export default __exports__